import React from 'react';
import { Badge } from '../components/ui/Badge';
import { Button } from '../components/ui/Button';
import { Section } from '../components/ui/Section';
import { AccordionItem } from '../components/ui/Accordion';
import { Check, X, Star, Shield, Download, AlertTriangle, Clock, FileText, Users, Zap, BookOpen, Calculator, PenTool, Target, TrendingUp, Award } from 'lucide-react';
export function LandingPage() {
  return <main className="min-h-screen w-full bg-white overflow-x-hidden font-['Inter'] selection:bg-blue-200 selection:text-blue-900" data-id="element-18">
      {/* 1. HERO SECTION */}
      <section className="bg-gradient-to-b from-blue-50/30 to-white pt-12 pb-16" data-id="element-19">
        <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-20">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-blue-100 text-blue-700 text-xs font-bold uppercase tracking-wider mb-6" data-id="element-21">
            <Calculator className="w-4 h-4" data-id="element-22" />
            PARA DOCENTES DE MATEMÁTICA
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-slate-900 leading-tight mb-4" data-id="element-23">
            ORGANIZA TODO TU AÑO DE
            <br data-id="element-24" />
            <span className="text-blue-600" data-id="element-25">MATEMÁTICA SIN ESTRÉS</span>
          </h1>

          {/* Product Image - REAL IMAGE */}
          <div className="relative w-full max-w-2xl mx-auto my-12" data-id="element-26">
            <img src="https://cdn.magicpatterns.com/uploads/5KoXbw1r3f9RP7n5sVtHZh/imagen.png" alt="MegaPack Matemáticas Lista" className="w-full h-auto drop-shadow-2xl hover:scale-105 transition-transform duration-500" data-id="element-27" />
          </div>

          <p className="text-lg text-slate-700 mb-2 font-medium" data-id="element-28">
            Sistema completo de proyectos, experiencias y evaluaciones listas
            para usar.
          </p>
          <p className="text-xl font-bold text-slate-900 mb-8" data-id="element-29">
            Todo tu año de Matemática resuelto{' '}
            <span className="text-slate-500 font-normal" data-id="element-30">(1.º a 6.º año)</span>
          </p>

          <button className="bg-blue-600 hover:bg-blue-700 text-white font-black text-lg px-8 py-4 rounded-full shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-200 mb-6" data-id="element-31">
            ¡LO QUIERO AHORA! →
          </button>

          <div className="flex flex-wrap justify-center gap-6 text-sm text-slate-600" data-id="element-32">
            <div className="flex items-center gap-2" data-id="element-33">
              <Check className="w-5 h-5 text-green-500" data-id="element-34" />
              <span data-id="element-35">Descarga inmediata</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-36">
              <Check className="w-5 h-5 text-green-500" data-id="element-37" />
              <span data-id="element-38">Garantía 7 días</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-39">
              <Check className="w-5 h-5 text-green-500" data-id="element-40" />
              <span data-id="element-41">Acceso de por vida</span>
            </div>
          </div>
        </div>
      </section>

      {/* 2. URGENCY WARNING BOX */}
      <section className="py-8" data-id="element-42">
        <div className="max-w-4xl mx-auto px-4" data-id="element-43">
          <div className="bg-red-50 border-2 border-red-200 rounded-2xl p-6 md:p-8" data-id="element-44">
            <div className="flex items-start gap-4" data-id="element-45">
              <AlertTriangle className="w-8 h-8 text-red-600 flex-shrink-0 mt-1" data-id="element-46" />
              <div data-id="element-47">
                <h3 className="text-xl font-black text-red-900 mb-4" data-id="element-48">
                  ⚠️ SEGUNDO SEMESTRE 2025 ESTÁ MUY CERCA... ¡NO TE QUEDES SIN
                  PLANIFICAR!
                </h3>
                <ul className="space-y-2 text-slate-700 mb-4" data-id="element-49">
                  <li className="flex items-start gap-2" data-id="element-50">
                    <span className="text-red-600 font-bold" data-id="element-51">•</span>
                    <span data-id="element-52">¿Sigues buscando recursos de último momento?</span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-53">
                    <span className="text-red-600 font-bold" data-id="element-54">•</span>
                    <span data-id="element-55">
                      ¿Pasas horas creando guías que podrías tener listas?
                    </span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-56">
                    <span className="text-red-600 font-bold" data-id="element-57">•</span>
                    <span data-id="element-58">
                      ¿Te preocupa no cubrir todo el programa a tiempo?
                    </span>
                  </li>
                </ul>
                <p className="font-bold text-slate-900" data-id="element-59">
                  Mientras tú lees esto, cientos de docentes ya están
                  descargando su MegaPack y organizando su año completo en
                  minutos...
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 3. COMPARISON TABLE */}
      <Section background="gray" data-id="element-60">
        <h2 className="text-3xl font-black text-center text-slate-900 mb-12" data-id="element-61">
          Elige la mejor opción
        </h2>
        <div className="flex justify-center" data-id="element-62">
          <div className="overflow-x-auto w-full max-w-4xl" data-id="element-63">
            <table className="w-full bg-white rounded-2xl shadow-lg overflow-hidden" data-id="element-64">
              <thead data-id="element-65">
                <tr className="bg-slate-100" data-id="element-66">
                  <th className="p-4 text-left font-bold text-slate-700" data-id="element-67">
                    Opción
                  </th>
                  <th className="p-4 text-center font-bold text-slate-700" data-id="element-68">
                    Planificar tú mismo
                  </th>
                  <th className="p-4 text-center font-bold text-slate-700" data-id="element-69">
                    Comprar suelto
                  </th>
                  <th className="p-4 text-center font-bold text-blue-700 bg-blue-50" data-id="element-70">
                    MEGAPACK (HOY)
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100" data-id="element-71">
                <tr data-id="element-72">
                  <td className="p-4 font-medium" data-id="element-73">Tiempo invertido</td>
                  <td className="p-4 text-center text-red-600 font-bold" data-id="element-74">
                    200+ horas
                  </td>
                  <td className="p-4 text-center text-orange-600 font-bold" data-id="element-75">
                    50+ horas
                  </td>
                  <td className="p-4 text-center text-green-600 font-bold bg-blue-50" data-id="element-76">
                    5 minutos
                  </td>
                </tr>
                <tr data-id="element-77">
                  <td className="p-4 font-medium" data-id="element-78">Costo total</td>
                  <td className="p-4 text-center" data-id="element-79">Tu tiempo</td>
                  <td className="p-4 text-center font-bold" data-id="element-80">$150+</td>
                  <td className="p-4 text-center font-bold text-blue-600 bg-blue-50" data-id="element-81">
                    $13.99
                  </td>
                </tr>
                <tr data-id="element-82">
                  <td className="p-4 font-medium" data-id="element-83">Todo el año cubierto</td>
                  <td className="p-4 text-center" data-id="element-84">
                    <X className="w-6 h-6 text-red-500 mx-auto" data-id="element-85" />
                  </td>
                  <td className="p-4 text-center" data-id="element-86">
                    <X className="w-6 h-6 text-red-500 mx-auto" data-id="element-87" />
                  </td>
                  <td className="p-4 text-center bg-blue-50" data-id="element-88">
                    <Check className="w-6 h-6 text-green-500 mx-auto" data-id="element-89" />
                  </td>
                </tr>
                <tr data-id="element-90">
                  <td className="p-4 font-medium" data-id="element-91">Editable</td>
                  <td className="p-4 text-center" data-id="element-92">
                    <Check className="w-6 h-6 text-green-500 mx-auto" data-id="element-93" />
                  </td>
                  <td className="p-4 text-center" data-id="element-94">
                    <X className="w-6 h-6 text-red-500 mx-auto" data-id="element-95" />
                  </td>
                  <td className="p-4 text-center bg-blue-50" data-id="element-96">
                    <Check className="w-6 h-6 text-green-500 mx-auto" data-id="element-97" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </Section>

      {/* 4. MEGAPACK FEATURES */}
      <section className="py-16 bg-white" data-id="element-98">
        <div className="max-w-5xl mx-auto px-4 text-center" data-id="element-99">
          <h2 className="text-3xl md:text-4xl font-black text-slate-900 mb-4" data-id="element-100">
            MEGAPACK MATEMÁTICA LISTA™
          </h2>
          <p className="text-lg text-slate-600 mb-12 max-w-2xl mx-auto" data-id="element-101">
            La única solución completa que necesitas para enseñar Matemática de
            1.º a 6.º año sin estrés
          </p>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6" data-id="element-102">
            {[{
            icon: Download,
            label: 'DIGITAL',
            color: 'green'
          }, {
            icon: PenTool,
            label: 'EDITABLE',
            color: 'green'
          }, {
            icon: Zap,
            label: 'FÁCIL DE USAR',
            color: 'green'
          }, {
            icon: TrendingUp,
            label: 'DESCARGA YA',
            color: 'green'
          }].map((item, i) => <div key={i} className="flex flex-col items-center gap-3 p-6 rounded-xl bg-green-50 border border-green-200" data-id="element-103">
                <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center" data-id="element-104">
                  <item.icon className="w-6 h-6 text-white" data-id="element-105" />
                </div>
                <span className="font-bold text-green-900 text-sm" data-id="element-106">
                  {item.label}
                </span>
              </div>)}
          </div>
        </div>
      </section>

      {/* 5. WHAT'S INCLUDED */}
      <Section background="blue" data-id="element-107">
        <div className="max-w-5xl mx-auto" data-id="element-108">
          <div className="flex flex-col md:flex-row items-center justify-center gap-12" data-id="element-109">
            <div className="flex-1 max-w-xl" data-id="element-110">
              <h2 className="text-3xl font-black text-slate-900 mb-6 text-center md:text-left" data-id="element-111">
                ¿Qué incluye el MegaPack?
              </h2>
              <ul className="space-y-3" data-id="element-112">
                {['✅ Proyectos ABP completos por unidad', '✅ Guías de ejercicios progresivos', '✅ Evaluaciones con rúbricas incluidas', '✅ Presentaciones PowerPoint editables', '✅ Actividades lúdicas y juegos', '✅ Material para todos los niveles (1.º a 6.º)', '✅ Planificaciones anuales listas', '✅ Banco de problemas resueltos'].map((item, i) => <li key={i} className="flex items-start gap-3 text-slate-700 font-medium" data-id="element-113">
                    <span className="text-lg" data-id="element-114">{item}</span>
                  </li>)}
              </ul>
            </div>
            <div className="flex-1 max-w-xl flex justify-center" data-id="element-115">
              <img src="https://cdn.magicpatterns.com/uploads/5KoXbw1r3f9RP7n5sVtHZh/imagen.png" alt="MegaPack Matemáticas Lista" className="w-full h-auto drop-shadow-2xl rounded-2xl hover:scale-105 transition-transform duration-500" data-id="element-116" />
            </div>
          </div>
        </div>
      </Section>

      {/* 6. WITH VS WITHOUT */}
      <section className="py-16 bg-white" data-id="element-117">
        <div className="max-w-5xl mx-auto px-4" data-id="element-118">
          <div className="grid md:grid-cols-2 gap-8" data-id="element-119">
            <div className="bg-green-50 border-2 border-green-200 rounded-2xl p-8" data-id="element-120">
              <h3 className="text-2xl font-black text-green-900 mb-6 flex items-center gap-3" data-id="element-121">
                <Check className="w-8 h-8" data-id="element-122" />
                Con el MegaPack Matemática
              </h3>
              <ul className="space-y-3" data-id="element-123">
                {['Planificas tu año en minutos', 'Material probado y efectivo', 'Más tiempo para ti y tu familia', 'Alumnos más motivados', 'Clases dinámicas y variadas'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-124">
                    <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-125" />
                    <span className="text-slate-700 font-medium" data-id="element-126">{item}</span>
                  </li>)}
              </ul>
            </div>

            <div className="bg-red-50 border-2 border-red-200 rounded-2xl p-8" data-id="element-127">
              <h3 className="text-2xl font-black text-red-900 mb-6 flex items-center gap-3" data-id="element-128">
                <X className="w-8 h-8" data-id="element-129" />
                Sin nuestro pack
              </h3>
              <ul className="space-y-3" data-id="element-130">
                {['Horas buscando recursos', 'Estrés de último momento', 'Fines de semana planificando', 'Material desorganizado', 'Clases repetitivas'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-131">
                    <X className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-132" />
                    <span className="text-slate-700 font-medium" data-id="element-133">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="text-center mt-12" data-id="element-134">
            <button className="bg-blue-600 hover:bg-blue-700 text-white font-black text-lg px-8 py-4 rounded-full shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-200" data-id="element-135">
              ¡LO QUIERO AHORA! →
            </button>
          </div>
        </div>
      </section>

      {/* 7. BONUSES */}
      <section className="py-16 bg-gradient-to-br from-yellow-50 via-orange-50 to-yellow-50" data-id="element-136">
        <div className="max-w-6xl mx-auto px-4" data-id="element-137">
          <div className="text-center mb-4" data-id="element-138">
            <span className="bg-gradient-to-r from-orange-500 to-red-500 text-white px-6 py-2 rounded-full text-sm font-black uppercase inline-block shadow-lg animate-pulse" data-id="element-139">
              🎁 SOLO POR HOY - BONOS GRATIS
            </span>
          </div>
          <h2 className="text-3xl md:text-5xl font-black text-center text-slate-900 mb-3" data-id="element-140">
            BONOS INCLUIDOS <span className="text-orange-600" data-id="element-141">GRATIS HOY</span>
          </h2>
          <p className="text-center text-xl text-slate-700 mb-3 font-bold" data-id="element-142">
            Más de <span className="text-3xl text-orange-600" data-id="element-143">$247</span> en
            valor agregado
          </p>
          <p className="text-center text-slate-600 mb-12" data-id="element-144">
            Estos bonos exclusivos solo están disponibles con tu compra de hoy
          </p>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8" data-id="element-145">
            {/* BONO 1 */}
            <div className="bg-white rounded-2xl shadow-xl overflow-hidden relative border-4 border-orange-200 transform hover:scale-105 transition-transform duration-300" data-id="element-146">
              <div className="absolute top-4 right-4 z-10" data-id="element-147">
                <span className="bg-red-500 text-white px-4 py-2 rounded-full text-xs font-black shadow-lg rotate-12 inline-block" data-id="element-148">
                  GRATIS
                </span>
              </div>
              <img src="https://cdn.magicpatterns.com/uploads/vAwbmpTKJaVfNwDJe68dum/bono_1.png" alt="Bono 1: Kit Premium de Evaluaciones" className="w-full h-64 object-cover" data-id="element-149" />
              <div className="p-6" data-id="element-150">
                <h3 className="text-xl font-black text-slate-900 mb-2" data-id="element-151">
                  BONO 1: Kit Premium de Evaluaciones
                </h3>
                <p className="text-slate-600 text-sm mb-4" data-id="element-152">
                  +50 evaluaciones listas con criterios de corrección incluidos
                </p>
                <div className="flex items-center gap-3" data-id="element-153">
                  <span className="text-slate-400 line-through text-lg" data-id="element-154">
                    $47
                  </span>
                  <span className="text-green-600 font-black text-2xl" data-id="element-155">
                    GRATIS
                  </span>
                </div>
              </div>
            </div>

            {/* BONO 2 */}
            <div className="bg-white rounded-2xl shadow-xl overflow-hidden relative border-4 border-orange-200 transform hover:scale-105 transition-transform duration-300" data-id="element-156">
              <div className="absolute top-4 right-4 z-10" data-id="element-157">
                <span className="bg-red-500 text-white px-4 py-2 rounded-full text-xs font-black shadow-lg rotate-12 inline-block" data-id="element-158">
                  GRATIS
                </span>
              </div>
              <img src="https://cdn.magicpatterns.com/uploads/iwCnHabpLJaNyy8FLLvEcX/bono_2.png" alt="Bono 2: Banco de Juegos y Actividades" className="w-full h-64 object-cover" data-id="element-159" />
              <div className="p-6" data-id="element-160">
                <h3 className="text-xl font-black text-slate-900 mb-2" data-id="element-161">
                  BONO 2: Banco de Juegos y Actividades
                </h3>
                <p className="text-slate-600 text-sm mb-4" data-id="element-162">
                  +30 recursos lúdicos para motivar tus clases
                </p>
                <div className="flex items-center gap-3" data-id="element-163">
                  <span className="text-slate-400 line-through text-lg" data-id="element-164">
                    $37
                  </span>
                  <span className="text-green-600 font-black text-2xl" data-id="element-165">
                    GRATIS
                  </span>
                </div>
              </div>
            </div>

            {/* BONO 3 */}
            <div className="bg-white rounded-2xl shadow-xl overflow-hidden relative border-4 border-orange-200 transform hover:scale-105 transition-transform duration-300" data-id="element-166">
              <div className="absolute top-4 right-4 z-10" data-id="element-167">
                <span className="bg-red-500 text-white px-4 py-2 rounded-full text-xs font-black shadow-lg rotate-12 inline-block" data-id="element-168">
                  GRATIS
                </span>
              </div>
              <img src="https://cdn.magicpatterns.com/uploads/eT1iZtt2yf495HMiXcjVZX/bono_3.png" alt="Bono 3: Plantillas Profesionales" className="w-full h-64 object-cover" data-id="element-169" />
              <div className="p-6" data-id="element-170">
                <h3 className="text-xl font-black text-slate-900 mb-2" data-id="element-171">
                  BONO 3: Plantillas Profesionales
                </h3>
                <p className="text-slate-600 text-sm mb-4" data-id="element-172">
                  Modelos semanales y mensuales listos para organizar tu año
                </p>
                <div className="flex items-center gap-3" data-id="element-173">
                  <span className="text-slate-400 line-through text-lg" data-id="element-174">
                    $57
                  </span>
                  <span className="text-green-600 font-black text-2xl" data-id="element-175">
                    GRATIS
                  </span>
                </div>
              </div>
            </div>

            {/* BONO 4 */}
            <div className="bg-white rounded-2xl shadow-xl overflow-hidden relative border-4 border-orange-200 transform hover:scale-105 transition-transform duration-300" data-id="element-176">
              <div className="absolute top-4 right-4 z-10" data-id="element-177">
                <span className="bg-red-500 text-white px-4 py-2 rounded-full text-xs font-black shadow-lg rotate-12 inline-block" data-id="element-178">
                  GRATIS
                </span>
              </div>
              <img src="https://cdn.magicpatterns.com/uploads/mRvHuH5bbccE3XRU1MX6Wy/bono_4.png" alt="Bono 4: Carpeta de Recursos por Áreas" className="w-full h-64 object-cover" data-id="element-179" />
              <div className="p-6" data-id="element-180">
                <h3 className="text-xl font-black text-slate-900 mb-2" data-id="element-181">
                  BONO 4: Carpeta de Recursos por Áreas
                </h3>
                <p className="text-slate-600 text-sm mb-4" data-id="element-182">
                  Material organizado por áreas temáticas para acceso rápido
                </p>
                <div className="flex items-center gap-3" data-id="element-183">
                  <span className="text-slate-400 line-through text-lg" data-id="element-184">
                    $39
                  </span>
                  <span className="text-green-600 font-black text-2xl" data-id="element-185">
                    GRATIS
                  </span>
                </div>
              </div>
            </div>

            {/* BONO 5 */}
            <div className="bg-white rounded-2xl shadow-xl overflow-hidden relative border-4 border-orange-200 transform hover:scale-105 transition-transform duration-300" data-id="element-186">
              <div className="absolute top-4 right-4 z-10" data-id="element-187">
                <span className="bg-red-500 text-white px-4 py-2 rounded-full text-xs font-black shadow-lg rotate-12 inline-block" data-id="element-188">
                  GRATIS
                </span>
              </div>
              <img src="https://cdn.magicpatterns.com/uploads/2DbHTvo5XucK8jt4vQW19v/bono_5.png" alt="Bono 5: Colección Resolvamos Problemas" className="w-full h-64 object-cover" data-id="element-189" />
              <div className="p-6" data-id="element-190">
                <h3 className="text-xl font-black text-slate-900 mb-2" data-id="element-191">
                  BONO 5: Colección "Resolvamos Problemas"
                </h3>
                <p className="text-slate-600 text-sm mb-4" data-id="element-192">
                  +50 problemas narrativos y de razonamiento para practicar
                </p>
                <div className="flex items-center gap-3" data-id="element-193">
                  <span className="text-slate-400 line-through text-lg" data-id="element-194">
                    $67
                  </span>
                  <span className="text-green-600 font-black text-2xl" data-id="element-195">
                    GRATIS
                  </span>
                </div>
              </div>
            </div>

            {/* BONUS EXTRA - Comunidad */}
          </div>

          {/* Total Value Summary */}
          <div className="bg-gradient-to-r from-green-500 to-emerald-600 rounded-2xl p-8 text-center shadow-2xl border-4 border-green-300" data-id="element-196">
            <h3 className="text-white text-2xl md:text-3xl font-black mb-4" data-id="element-197">
              🎉 VALOR TOTAL DE LOS BONOS:{' '}
              <span className="line-through opacity-75" data-id="element-198">$344</span>
            </h3>
            <p className="text-white text-xl font-bold mb-2" data-id="element-199">
              Hoy los recibes TODOS completamente GRATIS
            </p>
            <p className="text-green-100 text-sm" data-id="element-200">
              Solo disponible con tu compra en las próximas horas
            </p>
          </div>
        </div>
      </section>

      {/* 8. PRICING */}
      <section className="py-20 bg-gradient-to-b from-slate-900 to-slate-800 text-white" data-id="element-201">
        <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-202">
          <h2 className="text-4xl font-black mb-6" data-id="element-203">
            ACCESO COMPLETO DE POR VIDA
          </h2>
          <p className="text-xl text-slate-300 mb-12" data-id="element-204">
            Únete a más de 2,000 docentes que ya transformaron su enseñanza
          </p>

          <div className="bg-white text-slate-900 rounded-3xl p-10 max-w-lg mx-auto shadow-2xl relative" data-id="element-205">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-red-500 text-white px-6 py-2 rounded-full font-black text-sm shadow-lg" data-id="element-206">
              90% DE DESCUENTO HOY
            </div>

            <div className="mb-8" data-id="element-207">
              <p className="text-slate-500 text-sm mb-2" data-id="element-208">Valor real:</p>
              <p className="text-2xl text-slate-400 line-through mb-2" data-id="element-209">
                $197 USD
              </p>
              <div className="flex items-center justify-center gap-2" data-id="element-210">
                <span className="text-6xl font-black text-blue-600" data-id="element-211">
                  $13.99
                </span>
                <span className="text-xl text-slate-600 font-bold" data-id="element-212">USD</span>
              </div>
              <p className="text-green-600 font-bold mt-2" data-id="element-213">
                Ahorra más del 90%
              </p>
            </div>

            <ul className="text-left space-y-3 mb-8" data-id="element-214">
              {['✅ Acceso inmediato a todo el contenido', '✅ Actualizaciones gratuitas de por vida', '✅ Todos los bonos incluidos ($150 valor)', '✅ Soporte prioritario', '✅ Garantía de 7 días'].map((item, i) => <li key={i} className="flex items-start gap-2 text-sm font-medium" data-id="element-215">
                  <span data-id="element-216">{item}</span>
                </li>)}
            </ul>

            <button className="w-full bg-blue-600 hover:bg-blue-700 text-white font-black text-xl px-8 py-5 rounded-full shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-200 mb-4" data-id="element-217">
              ¡LO QUIERO AHORA! →
            </button>

            <p className="text-xs text-slate-500 flex items-center justify-center gap-2" data-id="element-218">
              <Shield className="w-4 h-4" data-id="element-219" />
              Pago 100% seguro y encriptado
            </p>
          </div>
        </div>
      </section>

      {/* 9. GUARANTEE BADGE */}
      <section className="py-12 bg-blue-50" data-id="element-220">
        <div className="max-w-3xl mx-auto px-4 text-center" data-id="element-221">
          <div className="inline-flex items-center gap-4 bg-white rounded-2xl p-6 shadow-lg" data-id="element-222">
            <div className="w-20 h-20 bg-blue-600 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-223">
              <Shield className="w-10 h-10 text-white" data-id="element-224" />
            </div>
            <div className="text-left" data-id="element-225">
              <h3 className="text-xl font-black text-slate-900 mb-1" data-id="element-226">
                Garantía de reembolso
              </h3>
              <p className="text-slate-600" data-id="element-227">
                <span className="font-bold text-blue-600" data-id="element-228">
                  100% de tu dinero de vuelta
                </span>{' '}
                si no estás satisfecho en 7 días
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 10. TESTIMONIALS */}
      <Section background="white" data-id="element-229">
        <h2 className="text-3xl font-black text-center text-slate-900 mb-12" data-id="element-230">
          LO QUE DICEN OTROS MAESTROS
        </h2>
        <div className="grid md:grid-cols-3 gap-8" data-id="element-231">
          {[{
          name: 'Prof. María González',
          text: 'Increíble recurso. Me ahorró semanas de trabajo y mis alumnos están más motivados que nunca.',
          stars: 5
        }, {
          name: 'Lic. Carlos Ramírez',
          text: 'La mejor inversión que he hecho como docente. Todo está perfectamente organizado y listo para usar.',
          stars: 5
        }, {
          name: 'Dra. Ana Martínez',
          text: 'Material de excelente calidad. Las evaluaciones son justas y los proyectos muy creativos.',
          stars: 5
        }].map((testimonial, i) => <div key={i} className="bg-slate-50 rounded-2xl p-6 border border-slate-200" data-id="element-232">
              <div className="flex gap-1 mb-4" data-id="element-233">
                {[...Array(testimonial.stars)].map((_, j) => <Star key={j} className="w-5 h-5 text-yellow-400 fill-yellow-400" data-id="element-234" />)}
              </div>
              <p className="text-slate-700 mb-4 italic" data-id="element-235">"{testimonial.text}"</p>
              <p className="font-bold text-slate-900" data-id="element-236">{testimonial.name}</p>
            </div>)}
        </div>
      </Section>

      {/* 11. FAQ */}
      <Section background="gray" data-id="element-237">
        <h2 className="text-3xl font-black text-center text-slate-900 mb-12" data-id="element-238">
          PREGUNTAS FRECUENTES
        </h2>
        <div className="max-w-3xl mx-auto bg-white rounded-2xl p-8 shadow-sm" data-id="element-239">
          <AccordionItem title="¿El material es editable?" data-id="element-240">
            Sí, todos los archivos vienen en formatos editables (Word,
            PowerPoint, Excel) para que puedas personalizarlos según tus
            necesidades.
          </AccordionItem>
          <AccordionItem title="¿Cómo recibo el acceso?" data-id="element-241">
            Inmediatamente después de tu compra recibirás un email con las
            instrucciones de acceso a nuestra plataforma donde podrás descargar
            todo el contenido.
          </AccordionItem>
          <AccordionItem title="¿Funciona para mi país?" data-id="element-242">
            Sí, el contenido matemático es universal y se adapta a los
            currículos de toda Latinoamérica y España.
          </AccordionItem>
          <AccordionItem title="¿Es un pago único?" data-id="element-243">
            Sí, pagas una sola vez y tienes acceso de por vida, incluyendo todas
            las actualizaciones futuras sin costo adicional.
          </AccordionItem>
          <AccordionItem title="¿Qué pasa si no me gusta?" data-id="element-244">
            Tienes 7 días para probarlo. Si no estás satisfecho, te devolvemos
            el 100% de tu dinero sin preguntas.
          </AccordionItem>
          <AccordionItem title="¿Incluye material para todos los niveles?" data-id="element-245">
            Sí, el MegaPack incluye material completo para 1.º, 2.º, 3.º, 4.º,
            5.º y 6.º año de secundaria.
          </AccordionItem>
        </div>
      </Section>

      {/* 12. GUARANTEE SECTION */}
      <section className="py-16 bg-blue-600" data-id="element-246">
        <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-247">
          <div className="flex justify-center mb-6" data-id="element-248">
            <div className="bg-white rounded-full w-32 h-32 flex flex-col items-center justify-center shadow-xl" data-id="element-249">
              <span className="text-4xl font-black text-blue-600" data-id="element-250">7</span>
              <span className="text-sm font-bold text-slate-600" data-id="element-251">DÍAS</span>
            </div>
          </div>
          <h2 className="text-3xl font-black text-white mb-4" data-id="element-252">
            Garantía de 7 días
          </h2>
          <p className="text-xl text-blue-100 max-w-2xl mx-auto" data-id="element-253">
            Prueba el MegaPack sin riesgo. Si no te convence, te devolvemos tu
            dinero completo. Sin preguntas, sin complicaciones.
          </p>
        </div>
      </section>

      {/* 13. FINAL CTA */}
      <section className="py-20 bg-gradient-to-b from-white to-blue-50" data-id="element-254">
        <div className="max-w-3xl mx-auto px-4 text-center" data-id="element-255">
          <h2 className="text-4xl font-black text-slate-900 mb-6" data-id="element-256">
            ¿Listo para transformar tu año escolar?
          </h2>
          <p className="text-xl text-slate-600 mb-8" data-id="element-257">
            Únete a miles de docentes que ya están enseñando sin estrés
          </p>
          <button className="bg-blue-600 hover:bg-blue-700 text-white font-black text-xl px-10 py-5 rounded-full shadow-xl hover:shadow-2xl transform hover:-translate-y-1 transition-all duration-200 mb-8" data-id="element-258">
            ¡QUIERO MI MEGAPACK AHORA! →
          </button>
          <div className="flex flex-wrap justify-center gap-6 text-sm text-slate-600" data-id="element-259">
            <div className="flex items-center gap-2" data-id="element-260">
              <Check className="w-5 h-5 text-green-500" data-id="element-261" />
              <span data-id="element-262">Descarga inmediata</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-263">
              <Check className="w-5 h-5 text-green-500" data-id="element-264" />
              <span data-id="element-265">Garantía 7 días</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-266">
              <Check className="w-5 h-5 text-green-500" data-id="element-267" />
              <span data-id="element-268">Acceso de por vida</span>
            </div>
          </div>
        </div>
      </section>

      {/* 14. FOOTER */}
      <footer className="bg-slate-900 text-slate-400 py-12" data-id="element-269">
        <div className="max-w-6xl mx-auto px-4" data-id="element-270">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-271">
            <p className="text-sm" data-id="element-272">
              © 2025 Matemática Lista. Todos los derechos reservados.
            </p>
            <div className="flex gap-6 text-sm" data-id="element-273">
              <a href="#" className="hover:text-white transition-colors" data-id="element-274">
                Términos y Condiciones
              </a>
              <a href="#" className="hover:text-white transition-colors" data-id="element-275">
                Política de Privacidad
              </a>
              <a href="#" className="hover:text-white transition-colors" data-id="element-276">
                Contacto
              </a>
            </div>
          </div>
        </div>
      </footer>
    </main>;
}